const data = {
  cases: [
    {
      url: '/innovation-by-design/2018',
      paramater: 'year',
      setTo: '2018'
    },
    {
      url: '/grant-thorton',
      paramater: 'tag',
      setTo: 'grant-thorton'
    }
  ]
};

export default data;
